import { useState } from "react";
import PolicyList from "@/components/prepaid/PolicyList";
import ReportP1 from "@/components/prepaid/ReportP1";
import HelpButton from "@/components/HelpButton";

const REGISTERS = [
  { code: "BD2", label: "BD2 (în uz)" },
  { code: "BD", label: "BD (istoric)" },
];
const VIEWS = [
  { key: "policies", label: "Polițe" },
  { key: "p1", label: "P1 · Raport lunar" },
];

export default function Prepaid() {
  const [registru, setRegistru] = useState("BD2");
  const [view, setView] = useState("policies");

  return (
    <div className="space-y-5">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Cheltuieli în avans</h1>
          <HelpButton anchor={view === "p1" ? "p1" : "polite"} />
        </div>
        <p className="text-sm text-slate-500">Polițe de asigurare repartizate pe zile și luni.</p>
      </div>

      <div className="flex flex-wrap gap-1 border-b">
        {REGISTERS.map((r) => (
          <button key={r.code} data-testid={`tab-register-${r.code}`} onClick={() => setRegistru(r.code)}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${registru === r.code ? "border-[#FFC800] text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            {r.label}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-1">
        {VIEWS.map((v) => (
          <button key={v.key} data-testid={`prepaid-view-${v.key}`} onClick={() => setView(v.key)}
            className={`px-3 py-1.5 text-xs font-semibold rounded transition-colors ${view === v.key ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
            {v.label}
          </button>
        ))}
      </div>

      <div key={`${registru}-${view}`}>
        {view === "policies" && <PolicyList registru={registru} />}
        {view === "p1" && <ReportP1 registru={registru} />}
      </div>
    </div>
  );
}
